import moment from 'moment'
import { mapState, mapGetters } from 'vuex'

export default {
  props: {
    myRdv: Boolean,
    date: {
      type: Object,
      required: true
    },
    filters: Object
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['calendarEvents']),
    ...mapGetters(['currentUserPk']),
    prettyDate () {
      return this.date.format('DD/MM/YYYY')
    },
    past () {
      return this.date.format('YYYYMMDD') < moment().format('YYYYMMDD')
    },
    accesses () {
      if (this.events && 'accesses' in this.events) {
        return Object.values(this.events.accesses)
      }
      return []
    },
    rdvs () {
      if (this.events && 'rdvs' in this.events) {
        let rdvs = Object.values(this.events.rdvs)
        if (this.myRdv) {
          rdvs = rdvs.filter(x => x.seller === this.currentUserPk)
        }
        if (this.filters) {
          if ('author' in this.filters && this.filters.author && this.filters.author.length) {
            let allAuthor = []
            let selectedAuthor = []
            this.filters.author.forEach(author => {
              selectedAuthor[author] = []
              selectedAuthor[author] = rdvs.filter(x => x.author === author.pk)
              allAuthor = allAuthor.concat(selectedAuthor[author])
            })
            rdvs = allAuthor
          }
          if ('contact' in this.filters && this.filters.contact && this.filters.contact.length) {
            let allContact = []
            let selectedContact = []
            this.filters.contact.forEach(contact => {
              selectedContact[contact] = []
              selectedContact[contact] = rdvs.filter(x => x.contact === contact.pk)
              allContact = allContact.concat(selectedContact[contact])
            })
            rdvs = allContact
          }
          if ('seller' in this.filters && this.filters.seller && this.filters.seller.length) {
            let allSeller = []
            let selectedSeller = []
            this.filters.seller.forEach(seller => {
              selectedSeller[seller] = []
              selectedSeller[seller] = rdvs.filter(x => {
                return x.seller === seller.pk
              })
              allSeller = allSeller.concat(selectedSeller[seller])
            })
            rdvs = allSeller
          }
          if ('rdv_type' in this.filters && this.filters.rdv_type && this.filters.rdv_type.length) {
            let rdvsType = []
            let allRdvType = []
            for (let type of this.filters.rdv_type) {
              rdvsType[type] = []
              rdvsType[type] = rdvs.filter(x => { return x.rdv_type === type })
              allRdvType = allRdvType.concat(rdvsType[type])
            }
            rdvs = allRdvType
          }
        }
        return rdvs
      }
      return []
    },
    options () {
      if (this.events && 'options' in this.events) {
        return Object.values(this.events.options)
      }
      return []
    },
    reminders () {
      if (this.events && 'reminders' in this.events) {
        return Object.values(this.events.reminders)
      }
      return []
    },
    users () {
      if (this.events && 'users' in this.events) {
        return Object.values(this.events.users)
      }
      return []
    },
    allEvents () {
      if (this.events) {
        return Object.values(this.events).reduce((tab, x) => {
          return tab.concat(Object.values(x))
        }, []).map(x => {
          if (x._type === 'rdvs') {
            x._date = x.date
          } else if (x._type === 'options') {
            x._date = x.end_date
          } else if (x._type === 'reminders') {
            x._date = x.date
          }
          return x
        })
      }
      return []
    },
    orderedEvents () {
      return this.allEvents.sort(function (a, b) {
        return new Date(b._date) - new Date(a._date)
      }).reverse()
    },
    totalEvents () {
      return this.allEvents.length
    },
    firstEvents () {
      let tab = []
      Object.entries(this.events).forEach(([key, val]) => {
        let total = Object.values(val).length
        if (total > 0 && tab.length < 3) {
          return Object.values(val).slice(0, 3)
        }
      })
      return tab
    },
    events () {
      let key = this.date.format('DD/MM/YYYY')
      if (key in this.calendarEvents) {
        return this.calendarEvents[key]
      }
      return null
    },
    day () {
      return this.date.format('DD')
    },
    month () {
      return this.date.format('MM')
    },
    monthSmall () {
      return this.date.format('MMM')
    },
    year () {
      return this.date.format('YYYY')
    },
    today () {
      return moment().format('DD/MM/YYYY')
    },
    isToday () {
      return this.date.isSame(moment(), 'day')
    }
  },
  methods: {
    goToDayView (panel) {
      this.$router.push({name: 'CalendarDayView', query: {day: this.day, month: this.month, year: this.year, panel}})
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/CalendarDayMixin.js